import { AccountabilityPartnership, AccountabilityPartnerStore } from '@stores/AccountabilityPartnerStore';
import apiResponse from '@stores/ApiResponse';
import { useMutation } from '@tanstack/react-query';

export class UpdateAccountabilityPartnershipsAction {
  constructor(private readonly store: AccountabilityPartnerStore = new AccountabilityPartnerStore()) {}

  public async execute(groupId: number, partnerships: AccountabilityPartnership[]) {
    await apiResponse.handleApiResponse<void>(() => this.store.adminUpdate(groupId, partnerships));
  }
}

export const useUpdateAccountabilityPartnershipsAction = () =>
  useMutation({
    mutationFn: (arg: { groupId: number; partnerships: AccountabilityPartnership[] }) => {
      const action = new UpdateAccountabilityPartnershipsAction();
      return action.execute(arg.groupId, arg.partnerships);
    },
  });
